const t=()=>{let t="";const a="0123456789abcdef";for(let o=0;o<36;o+=1)t+=8===o||13===o||18===o||23===o?"-":14===o?"4":19===o?a[4*Math.random()|8]:a[Math.floor(16*Math.random())];return t};export{t as default};
